export default __webpack_public_path__ + "static/media/arrow.f61aaa18.svg";